import { useState } from "react";
import { MessageCircle } from "lucide-react";
import { toast } from "sonner";
import { requestWhatsappPayment } from "@/lib/api";

export const WhatsappPayFallback = ({ plan, amount, hotelId, reservationRef, phone }) => {
  const [busy, setBusy] = useState(false);
  const go = async () => {
    setBusy(true);
    try {
      const r = await requestWhatsappPayment({ plan, amount, hotel_id: hotelId, reservation_ref: reservationRef, phone });
      if (!r.whatsapp_url) return toast.error("WhatsApp support non configure");
      toast.success(`Demande ${r.ref} enregistree, ouverture de WhatsApp...`);
      window.open(r.whatsapp_url, "_blank", "noopener");
    } catch (e) { toast.error(e.response?.data?.detail || "Echec de la demande"); } finally { setBusy(false); }
  };
  return (
    <button type="button" onClick={go} disabled={busy} className="w-full mt-3 inline-flex items-center justify-center gap-2 rounded-full border-2 border-emerald-500 text-emerald-700 font-bold py-2.5 text-sm hover:bg-emerald-50" data-testid="whatsapp-pay-fallback">
      <MessageCircle size={16} /> {busy ? "Envoi..." : "Plus de credit ? Envoyer ma demande par WhatsApp"}
    </button>
  );
};
